import { createThunk } from 'utils/createThunk';
import * as backendAPI from 'api/backendAPI/cart';
import types from 'constants/actionTypes';

export const fetchTotalCartQuantity = createThunk({
  apiCall: backendAPI.getTotalCartQuantity,
  type: types.GET_TOTAL_CART_QUANTITY_REQUEST,
});

export const fetchCart = createThunk({
  apiCall: backendAPI.getCart,
  type: types.GET_CART_REQUEST,
});

export const fetchAdditionalCart = createThunk({
  apiCall: backendAPI.getCart,
  type: types.GET_ADDITIONAL_CART_REQUEST,
});

export const selectAllTemplatesSerieBodyStyle = templateIds => {
  return {
    type: types.SELECT_ALL_TEMPLATES_CART_BODY_STYLE,
    payload: { templateIds },
  };
};

export const submitCart = createThunk({
  apiCall: backendAPI.submitCartTemplates,
  type: types.SUBMIT_CART_TEMPLATES_REQUEST,
});
